/**
 * Border radius tokens for rounded corners
 */
export const borderRadius = {
  /** Small elements: badges, tags, status pills */
  tag: "4px",

  /** Cards, containers, input fields, buttons */
  card: "8px",

  /** Modal corners, large panels */
  modal: "12px",

  /** Avatars, round buttons, progress dots */
  circle: "50%",
} as const;

export type BorderRadiusToken = keyof typeof borderRadius;
